<template>
    <div class="main">
        <div class="nav">
            <Nav :title="tit + '拜访报告'" :arrow="true" :type="$route.query.type"></Nav>
        </div>
        <div>
            <van-panel title="基本信息">
            </van-panel>
            <van-form>
                <!-- 主题 -->
                <van-field v-if="$route.query.type == 1" v-model="subject" name="主题" label="主题" placeholder="主题" readonly label-width="140"
                    :rules="[{ required: true, message: '请填写主题' }]" />
                <van-field v-if="$route.query.type == 2" v-model="subject2" name="主题" label="主题" placeholder="主题" readonly label-width="140"
                    :rules="[{ required: true, message: '请填写主题' }]" />
                <van-field v-if="$route.query.type == 3" v-model="subject3" name="主题" label="主题" placeholder="主题" readonly label-width="140"
                    :rules="[{ required: true, message: '请填写主题' }]" />
                    <!-- 客户 -->
                <van-field v-if="$route.query.type == 1" v-model="client" name="相关客户" label="相关客户" placeholder="相关客户" readonly label-width="140"
                    :rules="[{ required: true, message: '请填写相关客户' }]" />
                <van-field v-if="$route.query.type == 2" v-model="client2" name="相关客户" label="相关客户" placeholder="相关客户" readonly label-width="140"
                    :rules="[{ required: true, message: '请填写相关客户' }]" />
                <van-field v-if="$route.query.type == 2" v-model="shangjiname" name="商机名称" label="商机名称" placeholder="商机名称" readonly label-width="140"
                    :rules="[{ required: true, message: '请填写商机名称' }]" />
                <van-field v-if="$route.query.type == 3" v-model="client3" name="相关渠道" label="相关渠道" placeholder="相关渠道" readonly label-width="140"
                    :rules="[{ required: true, message: '请填写相关渠道' }]" />
                    <!-- 行业分类 -->
                <van-field v-model="mahyfl" v-if="$route.query.type == 1 || $route.query.type == 2" :name="'行业分类'" label="行业分类"
                    placeholder="" readonly label-width="140" />
                <van-field v-model="mahyfl1" v-if="$route.query.type == 3" :name="'渠道分类'" label="渠道分类" placeholder="" readonly
                    label-width="140" />
                    <!-- 是否变更 -->
                      <van-field readonly clickable name="picker" :value="hyflvalue" :label="tit1+'分类是否变更'" :placeholder="tit1+'分类是否变更'" label-width="140"
                    @click="hyflshowclockin = true" />
                <van-popup v-model="hyflshowclockin" position="bottom">
                    <van-picker show-toolbar :columns="HYFLTYPE" @confirm="onConfirmclockihyfl" @cancel="hyflshowclockin = false"
                       />
                </van-popup>
                <!-- 客户行业分类变更 -->
                <van-field v-if="$route.query.type == 1 &&hyflvalue=='是'|| $route.query.type == 2 &&hyflvalue=='是'" readonly clickable name="picker" 
                    :value="hyflxuanvalue" label="客户行业分类" placeholder="客户行业分类" label-width="140"
                    @click="hyflbgshowclockin = true" />
                <van-popup v-model="hyflbgshowclockin" position="bottom">
                    <van-picker show-toolbar :columns="hyflbglist" @confirm="onConfirmclockihyflbg"
                        @cancel="hyflbgshowclockin = false" value-key="codevalue" />
                </van-popup>
                <!-- 渠道分类变更 -->
                <van-field v-if="$route.query.type == 3&&hyflvalue=='是'" readonly clickable name="picker" :value="hyflxuanvalue"
                    label="渠道分类变更" placeholder="渠道分类变更" label-width="140" @click="hyflbgshowclockin1 = true" />
                <van-popup v-model="hyflbgshowclockin1" position="bottom">
                    <van-picker show-toolbar :columns="hyflbglist1" @confirm="onConfirmclockihyflbg1"
                        @cancel="hyflbgshowclockin1 = false" value-key="codevalue" />
                </van-popup>
                <!-- 被分被人 -->
                <van-field v-model="assignee" name="被分配人" label="被分配人" placeholder="被分配人" readonly label-width="140"
                    :rules="[{ required: true, message: '请填写被分配人' }]" />
                <van-field name="checkboxGroup" label="参与拜访人员" label-width="140">
                    <template #input>
                        <van-checkbox-group v-model="visiting_personnel" direction="horizontal">
                            <van-checkbox class="checkbox" name="MSR" shape="square">MSR</van-checkbox>
                            <van-checkbox class="checkbox" name="CLS销售经理" shape="square">CLS销售经理</van-checkbox>
                            <van-checkbox class="checkbox" name="省总经理理" shape="square">省总经理理</van-checkbox>
                            <van-checkbox class="checkbox" name="厂家销售人员" shape="square">厂家销售人员</van-checkbox>
                            <van-checkbox class="checkbox" name="服务人员" shape="square">服务人员</van-checkbox>

                        </van-checkbox-group>
                    </template>
                </van-field>
                <!-- 客户工程开工情况 -->
                <van-field v-if="$route.query.type == 1 || $route.query.type == 2"  readonly clickable name="picker" :value="khgckgvalue" label="客户开工情况" placeholder="请选择客户开工情况"
                    label-width="140" @click="khgckgshowclockin = true" />
                <van-popup v-model="khgckgshowclockin" position="bottom">
                    <van-picker show-toolbar :columns="khgckgmudilist" @confirm="onConfirmkhgckg"
                        @cancel="khgckgshowclockin = false" />
                </van-popup>
                <!-- 打卡信息 -->
                <van-field readonly clickable name="picker" :value="dakavalue" label="打卡信息" placeholder="点击选择打卡信息"
                    label-width="140" @click="showclockin = true" />
                <van-popup v-model="showclockin" position="bottom">
                    <van-picker class="picker-action-font-size" show-toolbar :columns="clockinArr"
                        @confirm="onConfirmclockin" @cancel="showclockin = false" value-key="clockintext" />
                </van-popup>
                <van-field v-model="visiting_contents" type="textarea" name="拜访内容" label="拜访内容" placeholder="拜访内容" rows="1"
                    label-width="140" autosize :rules="[{ required: true, message: '请填写拜访内容' }]" />
                <div class="image">
                    <van-image fit="contain" :src="dakaimg" />
                </div>
                <div style="margin: 16px;">
                    <van-button round block type="info" native-type="submit" @click="onSubmit" color="#FBAC01">发
                        布</van-button>
                </div>
            </van-form>
        </div>
        <!-- loading -->
        <van-overlay :show="showloading">
            <div style="width: 100%;height: 100%;display: grid;place-items: center;">
                <van-loading type="spinner" color="#1989fa" />
            </div>

        </van-overlay>
    </div>
</template>

<script>
import { qiweiAPI } from '../../../api/qiwei.js';
import Nav from './component/nav.vue';
import { Dialog } from 'vant';
export default {
    components: {
        Nav,
    },
    data() {
        return {
            tit: `${this.$route.query.type == 1  ? "客户" :this.$route.query.type == 2?'商机': "渠道"}`,
            tit1: `${this.$route.query.type == 1 || this.$route.query.type == 2 ? "行业" : "渠道"}`,
            subject: `面访签到[${this.$route.query.KHMC }]`,
            subject2: `面访签到[${this.$route.query.SJMC}]`,
            subject3: `面访签到[${this.$route.query.NAME}]`,
            client:  this.$route.query.KHMC ,
            client2: this.$route.query.KHNAME,
            shangjiname: this.$route.query.SJMC,
            client3: this.$route.query.NAME,
            visiting_contents: '',
            assignee: '',
            dakavalue: '',
            hyflvalue: '否',
            hyflxuanvalue: '',
            khgckgvalue: '',
            bfmdkgvalue: [],
            value: '',
            mahyfl: this.$route.query.INDUSTRYCLASSIFICATION ,
            mahyfl1: this.$route.query.CHANNELCATEGORY,
            columns: ['MSR', '分公司经理', '省总经理理', '省服务经理', '省销售经理', '分公司销售经理/主管', '省租赁经理', '省二手机经理', '省零件服务销售经'],
            clockinArr: [],
            showclockin: false,
            hyflshowclockin: false,
            hyflbgshowclockin: false,
            hyflbgshowclockin1: false,
            khgckgshowclockin: false,
            mfmdbgshowclockin: false,
            showloading: false,
            visiting_personnel: [],
            qw_clock_in_data: '',
            hyflbglist: ['AG15-农作物生产商', 'AG30-家畜生产商', 'AG35-多种经营', 'AG90-农业服务', 'AG95-农用设备OEM厂家', 'AG01-特殊农作物生产商', 'AG10-农场', 'AG31-乳业农场', 'AG40-定制作业/收割'],
            hyflbglist1: ['农机经销商', 'A农资经销商', '二手机商', '政府资源', '国有公司', '个人', '网红', '农机厂家', '农资厂家', '其他'],
            khgckgmudilist: ['检修季', '作业季', '收割季', '冬休季'],
            dakaimg: '',
            HYFLTYPE:['是','否'],
            // start_date : new Date().getTime()
        };
    },
    mounted() {
        console.log(this.$route.query);
        this.getClockInData()
        this.getUserData()
        // this.getIndustryClassData()

    },
    methods: {
        onSubmit(values) {

            this.showloading = true
            var params = {
                qw_user_id: this.$t.qiwei_yuangong_num,   //用户id
                crm_customer_code: this.$route.query.khbmccc,   //客户编码
                qw_clock_in_id: this.qw_clock_in_data,  //打卡数据数组格式
              
               
                assignee: this.assignee,   //呗分配人
                visiting_personnel: this.visiting_personnel,    //参与拜访人员,
                crm_data: this.$route.query,
                visiting_contents: this.visiting_contents,   //拜访内容
                visiting_source: this.$route.query.visiting_source,   //拜访来源

                // industry_class: this.mahyfl,    //行业分类
                is_change: this.hyflvalue,    //是否变更行业分类
                change_industry_class: this.hyflxuanvalue,    //变更后行业分类
                purpose_machine_visit: this.bfmdkgvalue,    //整机拜访目的
                operation_status: this.khgckgvalue,    //客户工程开工情况
                type: this.$route.query.type,  //:1=客户,2=商机,3=渠道
            }
            
            if(this.$route.query.type == 1){
                params.client= this.client   //客户
                params.subject= this.subject  //主题
            }else if(this.$route.query.type == 2){
                params.client= this.client2   //商机
                params.subject= this.subject2 
            }else if(this.$route.query.type == 3){
                params.client= this.client3   //渠道
                params.subject= this.subject3 
            }
            if (this.$route.query.type == 3) {
                params.industry_class = this.mahyfl1   //渠道分类
            } else {
                params.industry_class = this.mahyfl   //行业分类
            }
            this.$axios.post(qiweiAPI.KeLeShousubmitReport, params,{
                    
                    headers: this.$t.headers,
                  })
                .then((res) => {
                    console.log(res)
                    this.showloading = false
                    if (res.data.code == 1) {
                        Dialog.alert({
                            title: '提示',
                            message: '提交成功',

                        }).then(() => {
                            this.$router.push({ path: '/qiwei/keleshou/mianqian'})
                        });

                    } else {
                        Dialog.alert({
                            title: '提示',
                            message: res.data.msg,

                        })
                    }
                })
                .catch((res) => {
                    console.log(res);
                });
        },
         // 行业变更类型选择
        onConfirmclockihyfl(value, index) {
            this.hyflvalue = value
            if(value=='否'){
                this.hyflxuanvalue = ''
            }
            this.hyflshowclockin= false
        },
        // 行业变更选择
        onConfirmclockihyflbg(value, index) {
            console.log(value)
            this.hyflxuanvalue = value
            if (this.hyflvalue == '否') {
                this.hyflxuanvalue = ''
            }
            this.hyflbgshowclockin = false
        },
        // 渠道变更选择
        onConfirmclockihyflbg1(value, index) {
            console.log(value)
            this.hyflxuanvalue = value
            if (this.hyflvalue == '否') {
                this.hyflxuanvalue = ''
            }
            this.hyflbgshowclockin1 = false
        },
        // 整机拜访目的
        onConfirmclockibfmdkg(value, index) {
            this.bfmdkgvalue = value
            this.mfmdbgshowclockin = false
        },

        // 客户工程开工
        onConfirmkhgckg(value, index) {
            this.khgckgshowclockin = false
            this.khgckgvalue = value
            console.log(this.khgckgvalue)
        },

        onConfirmclockin(value, index) {
            console.log(value);

            this.dakavalue = this.clockinArr[index].location_detail;
            this.showclockin = false;
            console.log(`当前值：${value}, 当前索引：${index}`);

            // 绑定图片
            this.$axios
                .post(qiweiAPI.getMediaData, {
                    clockin_data: value,
                },{
                    
                  headers: this.$t.headers,
                })
                .then((res) => {
                    console.log(res)
                    if (res.data.code == 1) {
                        this.dakaimg = res.data.data.oss_attachments[0]
                        this.qw_clock_in_data = res.data.data.id
                    }
                })
                .catch((res) => {
                    console.log(res);
                });
        },

        // 获取打卡信息
        getClockInData() {
            this.$axios
                .get(qiweiAPI.KeLeShougetClockInData, {
                    params: {
                        qw_user_id: this.$t.qiwei_yuangong_num
                        // qw_user_id: 'BJRF016'
                    },
                  headers: this.$t.headers,
                })
                .then((res) => {
                    console.log(res)
                    if (res.data.code == 1) {
                        this.clockinArr = res.data.data
                    }
                })
                .catch((res) => {
                    console.log(res);

                });
        },
        // 获取用户信息
        getUserData() {
            this.$axios
                .get(qiweiAPI.KeLeShouUserData, {
                    params: {
                        qw_user_id: this.$t.qiwei_yuangong_num
                    },
                  headers: this.$t.headers,
                })
                .then((res) => {
                    console.log(res)
                    if (res.data.code == 1) {
                        this.assignee = res.data.data.name

                    }
                })
                .catch((res) => {
                    console.log(res);
                });
        },


    },
}
</script>

<style>
.main {
    width: 100%;
}

.checkbox {
    margin-bottom: 6px;
}

.image {
    width: 100%;
    margin-top: 20px;
    display: grid;
    place-items: center;
    overflow: hidden;
}

.image>.van-image {
    width: 80%;
    overflow: hidden;
}

.image img {
    width: 100%;
    overflow: hidden;
}

.picker-action-font-size {
    font-size: 10px;

}

.van-picker-column {
    font-size: 12px;
}

.van-ellipsis {
    font-size: 12px;
    text-align: center;
    white-space: normal;
    /* text-overflow: ellipsis; */
}</style>


// WEBPACK FOOTER //
// src/pages/qiwei/keleshou/checkin.vue